const getters = {
    is_authenticated: (state) => {
        return !!state.token
    },
    remember_user: (state) => {
        return !!localStorage.getItem('auth')
    },
    token: (state) => {
        return state.token
    },
    has_role: (state, getters) => {
        return function (roles) {
            try {
                if (!Array.isArray(roles)) {
                    roles = [...arguments].where((r) => r)
                }

                if (!roles.any()) {
                    return true
                }

                if (!getters.is_authenticated) {
                    return false
                }

                return roles.any((r) => {
                    const currentUserRole = state.current_user.roles.map((r) => r.toLowerCase())
                    return currentUserRole.includes(r.toLowerCase())
                })
            } catch (e) {
                console.error('error in Auth.getters.has_role: ', e)
            }
            return false
        }
    },
    current_user: (state) => {
        return state.current_user
    },
    current_roles: (state) => {
        return state.current_user.roles
    }
}

export default getters
